import Resource from "../resource";
import request from "../../utils/request";
import { publicApiAuthHeaders } from "@/utils/publicApiAuth";

class Admission extends Resource {
  constructor() {
    super("admission");
  }

  verifiedEmail(data) {
    return request({
      url: `/admission/apply`,
      method: "put",
      data: data.query,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  lookups(id) {
    return request({
      url: `/admission/website/applicant/lookups${id ? "/" + id : ""}`,
      method: "get",
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  admissionData(data) {
    return request({
      url: `/website/admissionData`,
      method: "get",
      params: {
        language: data.lang
      },
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  print(payload) {
    return request({
      url: `/admission/website/print-pdf/${payload.id}${
        payload.installment_id ? "/" + payload.installment_id : ""
      }`,
      method: "get",
      responseType: "blob",
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  needTraning(data) {
    return request({
      url: `/admission/faculty/needTraining/${data.type}/${data.id}`,
      method: "get",
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  getApplicant(data) {
    return request({
      url: `/admission/${data.id}/${data.key}`,
      method: "get",
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  createTransaction(payload) {
    return request({
      url: `/admission/website/transaction/create${
        payload.id ? "/" + payload.id : ""
      }`,
      method: "post",
      data: payload.query,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  checkBankMisrPaymentStatus(data) {
    return request({
      url: `/admission/website/transaction/check/${data.transaction}${
        data.id ? "/" + data.id : ""
      }`,
      method: "post",
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  save(data) {
    return request({
      url: `/admission/${data.id || 2}/${data.key}`,
      method: "post",
      data: data.query,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }

  createDirectories(payload) {
    return request({
      url: `/archive`,
      method: "put",
      data: payload,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  destroy(id) {
    return request({
      url: `/archive/${id}`,
      method: "delete",
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  pay(id, query) {
    let url = `/payments/pay/${id}`;
    return request({
      url: url,
      method: "post",
      data: query,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  upload(resource, id) {
    return request({
      url: `/archive/upload${id}`,
      method: "post",
      data: resource,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  setContent(payload) {
    return request({
      url: `/archive/update_page/${payload.id}`,
      method: "post",
      data: {
        body: payload.body,
        language: payload.language
      },
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
  rename(resource) {
    return request({
      url: `/archive${resource.id ? "/" + resource.id : ""}`,
      method: "put",
      data: resource.resource,
      headers: publicApiAuthHeaders(),
      admission: true
    });
  }
}

export { Admission as default };
